import {
  addDays,
  addHours,
  addMonths,
  addWeeks,
  differenceInDays,
  differenceInMonths,
  endOfDay,
  endOfHour,
  endOfMonth,
  endOfWeek,
  isEqual,
  startOfDay,
  startOfHour,
  startOfMonth,
  startOfWeek,
  subMilliseconds
} from "./date"

export type TimeFrame = 'HOUR' | 'DAY' | 'WEEK' | 'MONTH'

export const getDefaultTimeFrame = (fromDttm: number, toDttm: number = new Date().getTime()): TimeFrame => {
  const diffInMonths = differenceInMonths(toDttm, fromDttm)

  if (diffInMonths >= 3) {
    return "MONTH"
  }

  const diffInDays = differenceInDays(toDttm, fromDttm)
  if (diffInDays >= 60) {
    return "WEEK"
  }

  if (diffInDays >= 3) {
    return "DAY"
  }

  return "HOUR"
}

export const getTimeFrameDates = (timeFrame: TimeFrame, fromDttm: number, toDttm: number) => {
  if (timeFrame === 'HOUR') {
    const isEndStart = isEqual(startOfHour(toDttm), toDttm)
    const endDttm = endOfHour(isEndStart ? subMilliseconds(toDttm, 1) : toDttm)
    return {
      startDttm: startOfHour(fromDttm),
      endDttm: endDttm,
    }
  } else if (timeFrame === "DAY") {
    const isEndStart = isEqual(startOfDay(toDttm), toDttm)
    const endDttm = endOfDay(isEndStart ? subMilliseconds(toDttm, 1) : toDttm)
    return {
      startDttm: startOfDay(fromDttm),
      endDttm: endDttm,
    }
  } else if (timeFrame === "WEEK") {
    const isEndStart = isEqual(startOfWeek(toDttm), toDttm)
    const endDttm = endOfWeek(isEndStart ? subMilliseconds(toDttm, 1) : toDttm)
    return {
      startDttm: startOfWeek(fromDttm),
      endDttm: endDttm,
    }
  } else {
    const isEndStart = isEqual(startOfMonth(toDttm), toDttm)
    const endDttm = endOfMonth(isEndStart ? subMilliseconds(toDttm, 1) : toDttm)
    return {
      startDttm: startOfMonth(fromDttm),
      endDttm: endDttm,
    }
  }
}

export const startOf = (timeFrame: TimeFrame, date: Date | number): Date => {
  if (timeFrame === 'HOUR') {
    return startOfHour(date)
  } else if (timeFrame === "DAY") {
    return startOfDay(date)
  } else if (timeFrame === "WEEK") {
    return startOfWeek(date)
  } else {
    return startOfMonth(date)
  }
}

export const addTime = (timeFrame: TimeFrame, date: Date | number, amount: number): Date => {
  if (timeFrame === 'HOUR') {
    return addHours(date, amount)
  } else if (timeFrame === "DAY") {
    return addDays(date, amount)
  } else if (timeFrame === "WEEK") {
    return addWeeks(date, amount)
  } else {
    return addMonths(date, amount)
  }
}
